import { render, staticRenderFns } from "./relationship_type_edit.vue?vue&type=template&id=865f4d10&scoped=true&"
import script from "./relationship_type_edit.vue?vue&type=script&lang=js&"
export * from "./relationship_type_edit.vue?vue&type=script&lang=js&"
import style0 from "./relationship_type_edit.vue?vue&type=style&index=0&id=865f4d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865f4d10",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VCombobox,VContainer,VDivider,VForm,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src515608046/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865f4d10')) {
      api.createRecord('865f4d10', component.options)
    } else {
      api.reload('865f4d10', component.options)
    }
    module.hot.accept("./relationship_type_edit.vue?vue&type=template&id=865f4d10&scoped=true&", function () {
      api.rerender('865f4d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/relationship_type_edit.vue"
export default component.exports